import * as React from 'react';
import { PhoneButtonStickyLayout } from './components/PhoneButtonStickyLayout';
import { CallPhoneButton } from './components/CallPhoneButton';

export interface IPhoneButtonMobileProps {
  onClick?(): void;
  phone: string;
}

export const PhoneButtonMobile: React.FC<IPhoneButtonMobileProps> = ({ phone, onClick }) => {
  return (
    <PhoneButtonStickyLayout>
      <CallPhoneButton phone={phone} onClick={onClick} />
    </PhoneButtonStickyLayout>
  );
};
